import { app_url } from "app_config"
import Breadcrumb from "components/Common/Breadcrumb"
import React, { useEffect } from "react"
import { Link, useNavigate, useParams } from "react-router-dom"
import { Container, CardBody, Card, Col, Row } from "reactstrap"

import AllAutoEmail from "./Automate Email"

const EmailsIndex = () => {
  useEffect(() => {
    document.title = "Email | Peacock Accountants Limited"
  }, [])

  return (
    <div>
      <div className="page-content mb-5">
        <Container fluid>
          <Breadcrumb title={"Dashboard"} breadcrumbItem={"Email Templates"} />
          <div>
            <Row>
              {/* <Col md={2} className='pe-1'>
                                <Card>
                                    <CardBody className=' rounded custom_side_nav p-2'>
                                        {
                                            tabs.map((tab) => {
                                                return (
                                                    <div key={tab} className='mb-2'>
                                                        <Link
                                                            to={`${app_url}emails/${tab}`}
                                                            className={`side_navlink text-capitalize ${tab === tab_name && 'bg-white fw-bold'}`}
                                                        >

                                                            {tab.replaceAll('-', ' ')}</Link>
                                                    </div>
                                                )
                                            })
                                        }
                                    </CardBody>
                                </Card>
                            </Col> */}
              <Col md={12}>
                <Card>
                  <CardBody>
                    {/* {
                                            tab_name === tabs[0] &&
                                            <AllEmail />
                                        } */}

                    <AllAutoEmail />
                    {/* {
                                            tab_name === tabs[0] &&
                                        } */}
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </div>
        </Container>
      </div>
    </div>
  )
}

export default EmailsIndex
